import request from '@/utils/request'

export function getUserInfo(data) {
  return request({
    url: 'appmanage/external/information/getUserInfo',
    method: 'post',
    data
  })
}
export function updateUserInfo(data) {
  return request({
    url: 'appmanage/external/information/updateUserInfo',
    method: 'post',
    data
  })
}
export function getLibrary(data) {
  return request({
    url: 'appmanage/external/musicLibrary/getLibrary',
    method: 'post',
    data
  })
}
export function uploadFreeMusic(data) {
  return request({
    url: 'appmanage/external/musicLibrary/uploadFreeMusic',
    method: 'post',
    data
  })
}
export function upLrc(data) {
  return request({
    url: 'oss/lyricUpload',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/personal.js